import React, { Component }from 'react';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import { Translate, Localize } from 'react-redux-i18n';

import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import CashFormatter from '../Common/cashFormatter';
import checkPermission from '../Common/permissions';
import Spinner from '../../components/Widgets/spinner';
import ReceiveModal from '../../containers/Inventories/receiveModal'
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { 
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isCPG, isVAK, isSH, isVIP 
} from '../../actions/root_url';

const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
const isUSPride = ROOT_API_URL === "https://uspride-scm.truckxi.com/api/" || ROOT_URL === "https://uspride-scm.truckxi.com/api/";

class FilterToolbar extends React.Component {
  componentDidMount() {
    this.props.onToggleFilter();
  }

  render() {
    return <Toolbar {...this.props} />
  }
}
  

class ReceiveList extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,
      createOpen: false,
      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      gourpOpen: false
    };

    this.handleResize = this.handleResize.bind(this);

    this.openCreate = this.openCreate.bind(this);
    this.closeCreate = this.closeCreate.bind(this);
    this.receiving = this.receiving.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchReceives();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.warehouse !== this.props.warehouse) {
      this.props.fetchReceives();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Once purchaseOrders is ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.receives && nextProps.receives != this.props.receives) {
      let receives = nextProps.receives;
      let newRows = [];
      receives.map(
        receive => {
          let newReceive = {};

          if(receive.Vendor){
            newReceive["VendorNum"] = receive.Vendor.VendorNum;
            newReceive["vendorName"] = receive.Vendor.Name;
            newReceive["VendorDescription"] = receive.Vendor.Description;
          }
          if(receive.Purchaser){
            newReceive["Purchaser"] = receive.Purchaser;
          }
          if(receive.DeliverWarehouse){
            newReceive["WarehouseName"] = receive.DeliverWarehouse.Name;
            newReceive["Warehouse_id"] = receive.DeliverWarehouse.Warehouse_id;
          }
          newReceive["PONum"] = receive.PONum;
          newReceive["PurchaseStatus"] = receive.PurchaseStatus;
          newReceive["ShippingCost"] = receive.ShippingCost;
          newReceive["MiscCost"] = receive.MiscCost;
          newReceive["FinalPrice"] = receive.FinalPrice;
          newReceive["OrderDate"] = receive.OrderDate;
          newReceive["ETADate"] = receive.ETADate;
          newReceive["container_num"] = receive.container_num;
          newRows = [...newRows, newReceive];
        }
      )
      this.setState({
          rows: newRows
      });
    }
  }

  openCreate() { this.setState({ createOpen: true }); }
  closeCreate() { this.setState({ createOpen: false }); }

  receiving(e) {
    e.preventDefault();
    const currentReceive = this.state.selectedRows[0];
    this.props.resetCurrentReceive();
    this.props.selectReceive(currentReceive);
    this.context.router.push('/inventories/receive/'+currentReceive.PONum);
  }


  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
  }

  // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
  setCurrentReceive(e) {
    e.preventDefault();
    const currentReceive = this.state.selectedRows[0];
    this.props.selectReceive(currentReceive);
  }

  clickNew(e) {
    e.preventDefault();
    // this.props.resetCurrentReceive();
    this.context.router.push('/inventories/receive/new')
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    if (this.props.isLoading && !this.props.error) return <Spinner/>
    else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
    else {
      // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      // Handle the row select function
      const onRowSelect = rows => {
        this.setState(...this.state, { selectedRows: rows });
      }

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState(state);
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      }

      // Handle the editable function
      const handleRowUpdated = e => {
        // merge updated row with current row and rerender by setting state
        let rows = this.state.rows.slice(0);
        let editedRows = this.state.editedRows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.Product_id === rows[e.rowIdx].Product_id)
            editedRows.splice(index, 1)
        }, this);
        // push the row into the editedRows array
        editedRows.push(rows[e.rowIdx]);
        this.setState({
          rows: rows,
          editedRows: editedRows
        });
      }

      //Custom Formatter component
      const IsEnabledFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
          else return <span className="label label-danger"><Translate value="disable" /></span>;
        }
      });

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let date = new Date(this.props.value)
            let index = dateMap.indexOf(date.toString().slice(4,3));
            let localDate = index + date.toString().slice(8, 6);
            return <span>{date.toString().slice(4, 15)}</span>;;
          }
          else return <span className="label label-danger">-</span>;
        }
      });

      const POStatus = React.createClass({
        render() {
          if(!this.props.value) return <span></span>
          if(isVAK) {
            return <span><Translate value={this.props.value == 'Placed' ? 'receive_placed': this.props.value } /></span>;
          } else {
            return <span>{this.props.value}</span>;
          }
        }
      })

      // Column difinition
      const columns = [
        ...isSH && [{
          key: 'PONum',
          name: <Translate value="sa_file_no" />,
          resizable: true,
          width: 135,
          sortable: true,
          filterable: true,
        }], 
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'vendorName',
          name: <Translate value="name" />,
          resizable: true,
          width: 180,
          sortable: true,
          width: 180,
          filterable: true
        }, {
          key: 'VendorDescription',
          name: <Translate value="desc" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        },
        ...isUSPride ? [{
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }] : [],
        ...!isSH && [{
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          width: 135,
          sortable: true,
          filterable: true,
        }], {
          key: 'PurchaseStatus',
          name: <Translate value={isSH ? "sa_status" : "po_status"} />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
          formatter: POStatus
        }, {
          key: 'Purchaser',
          name: <Translate value="purchaser" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'WarehouseName',
          name: <Translate value="ship_to" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'ShippingCost',
          name: <Translate value="shipping_dollarsign" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'MiscCost',
          name: <Translate value="misc_dollarsign" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'OrderDate',
          name: <Translate value="order_date" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: DateFormatter
        }, {
          key: 'ETADate',
          name: <Translate value="est_date" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: DateFormatter
        }
      ];

      const columnsTN = [
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'vendorName',
          name: <Translate value="name" />,
          resizable: true,
          width: 180,
          sortable: true,
          width: 180,
          filterable: true
        }, {
          key: 'VendorDescription',
          name: <Translate value="desc" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          width: 120,
          sortable: true,
          filterable: true,
        }, {
          key: 'PurchaseStatus',
          name: <Translate value="po_status" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true
        }, {
          key: 'Purchaser',
          name: <Translate value="purchaser" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: false,
        }, {
          key: 'WarehouseName',
          name: <Translate value="ship_to" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
        }, {
          key: 'ShippingCost',
          name: <Translate value="shipping_dollarsign" />,
          resizable: true,
          width: 95,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'MiscCost',
          name: <Translate value="misc_dollarsign" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'FinalPrice',
          name: <Translate value="final_dollarsign" />,
          resizable: true,
          width: 80,
          sortable: true,
          filterable: true,
          formatter: CashFormatter,
        }, {
          key: 'OrderDate',
          name: <Translate value="order_date" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: DateFormatter
        }, {
          key: 'ETADate',
          name: <Translate value="est_date" />,
          resizable: true,
          width: 100,
          sortable: true,
          filterable: true,
          formatter: DateFormatter
        }
      ];

      if (isCPG || isVIP) {
        const descIndex = _.findIndex(columns, { key: "VendorDescription" });
        columns.splice(descIndex, 1);
      }

      return (
        <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="ReceiveList-dataGrid1">
          <ReactDataGrid
            rowKey='PONum'
            toolbar={<FilterToolbar enableFilter/>}
            enableCellSelect={true}
            onGridSort={handleGridSort}
            onAddFilter={handleFilterChange}
            columns={isTN ? columnsTN : columns}
            headerRowHeight={45}
            rowGetter={rowGetter}
            rowsCount={getSize() }
            rowHeight={25}
            minHeight={685}
            enableRowSelect='single'
            onRowUpdated={handleRowUpdated}
            onRowSelect={onRowSelect}
          />
        </div></Col></Row>
      )
    }
  }

  render() {
    let createDialogStyle = {
      width: '400px',
      marginLeft: '-10%',
    };
    return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="warehouse_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="new_receiving" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <Grid id="receive-list">
            <Panel className="position-relative table-collapse-fix">
            {/* <div className="content-heading"><Translate value="inventory_receive" /></div> */}
            <ButtonToolbar>
                { /* <Button href="/inventories"  bsStyle="success" ><em className="fa fa-mail-reply"/></Button> */}
                <Button
                  bsStyle="success"
                  disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("add_receive") }
                  onClick={this.receiving}>
                    <em className="fa fa-plus marginRightStyle" /><Translate value="create_receiving" />
                </Button>
            </ButtonToolbar>
            {this.renderTable() }
          </Panel>
          </Grid>
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}



export default ReceiveList;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveList.jsx